/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared';
import {
  TSeourlsGetSeoUrlsFromQueryStringsModel,
  ISeourlsGetSeoUrlsFromQueryStringsRequest,
  IMappers,
  ISeourlsGetSeoUrlsFromQueryStringsResponse,
  ISeourlsGetSeoUrlsFromQueryStringsResponseError,
  TSeourlsGetSeoUrlsFromQueryStringsResponse,
} from './types';

const defaultConfig: TSeourlsGetSeoUrlsFromQueryStringsModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'monolith-python',
  pathApi: '/seourls/get-seo-urls-from-query-strings/',
  hostType: 'api',
} as TSeourlsGetSeoUrlsFromQueryStringsModel;

function createSeourlsGetSeoUrlsFromQueryStringsModel(
  parameters: ISeourlsGetSeoUrlsFromQueryStringsRequest,
): TSeourlsGetSeoUrlsFromQueryStringsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISeourlsGetSeoUrlsFromQueryStringsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISeourlsGetSeoUrlsFromQueryStringsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchSeourlsGetSeoUrlsFromQueryStrings<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISeourlsGetSeoUrlsFromQueryStringsOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TSeourlsGetSeoUrlsFromQueryStringsResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createSeourlsGetSeoUrlsFromQueryStringsModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISeourlsGetSeoUrlsFromQueryStringsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ISeourlsGetSeoUrlsFromQueryStringsResponseError);
    }
  }

  return { response, statusCode } as TSeourlsGetSeoUrlsFromQueryStringsResponse;
}

export { defaultConfig, createSeourlsGetSeoUrlsFromQueryStringsModel, fetchSeourlsGetSeoUrlsFromQueryStrings };
